export const getOrdinal = d => {
	const t = d % 10;
	return Math.floor((d % 100 / 10)) === 1 ? "th" :
		t === 1 ? "st" :
			t === 2 ? "nd" :
				t === 3 ? "rd" :
					"th"
};
